import { Skeleton, Typography } from "antd";

import {
  getLogoTitleLevel,
  getSkeletonHeight,
  getSkeletonWidth,
  useLogoStyles,
} from "./logo-style";

import type { CompanyLogoProps } from "./types";

export function TextLogo({ size = "default", company, testIdPrefix }: CompanyLogoProps) {
  const { styles } = useLogoStyles({ size });
  const logoTestId = `${testIdPrefix}-text-logo`;
  const logoContentTestId = `${logoTestId}-content`;

  return (
    <div className={styles.logoContainer} data-testid={logoTestId}>
      {company ? (
        <Typography.Title
          level={getLogoTitleLevel(size)}
          className={styles.textLogo}
          data-testid={logoContentTestId}
          title={company.commonName}
        >
          {company.commonName}
        </Typography.Title>
      ) : (
        <div data-testid={logoContentTestId}>
          <Skeleton.Input
            active
            size="small"
            style={{
              width: getSkeletonWidth(size),
              height: getSkeletonHeight(size),
            }}
          />
        </div>
      )}
    </div>
  );
}
